import { render, staticRenderFns } from "./FeaturePricing.vue?vue&type=template&id=78599010&scoped=true&"
import script from "./FeaturePricing.vue?vue&type=script&lang=js&"
export * from "./FeaturePricing.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78599010",
  null
  
)

export default component.exports